import { Box, LinearProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { ClipObjectPending } from '../../../context/clips';
import { StudioClipContext } from '../StudioClip';

const useStyles = makeStyles()(() => ({
  progressBar: {
    borderRadius: 4,
  },
}));

const Rendering = () => {
  const { clip } = useContext(StudioClipContext);
  const { classes } = useStyles();
  const [progress, setProgress] = useState<number>(0);

  const onStreamProgress = useCallback(
    (event: ProgressEvent) => {
      if (event.lengthComputable) {
        setProgress((event.loaded / event.total) * 100);
      }
    },
    [setProgress]
  );

  const onStreamLoad = useCallback(() => {
    // TODO: update clip src to equal stream.getObjectURL()
  }, []);

  useEffect(() => {
    const stream = (clip as ClipObjectPending).streamRequest;
    // prevent pending clip without stream from registering events
    // IE: in the case of combining clips
    if (!stream) {
      return () => {};
    }
    // Setup stream event listeners to track progress
    stream.addEventListener('progress', onStreamProgress);
    stream.addEventListener('load', onStreamLoad);
    return () => {
      // Remove event listeners on unmount
      stream.removeEventListener('progress', onStreamProgress);
      stream.removeEventListener('load', onStreamLoad);
    };
  }, [clip, onStreamLoad, onStreamProgress]);

  return (
    <Box marginLeft={1} marginRight={1} width="100%">
      <LinearProgress
        className={classes.progressBar}
        color="primary"
        value={progress}
        variant={progress > 0 ? 'determinate' : 'indeterminate'}
      />
    </Box>
  );
};

export default Rendering;
